import { OffsetState, OffsetStateParams } from '../../states/OffsetState'

export class OffsetStateGPU extends OffsetState {

  public commitChanges(changes: OffsetStateParams) {
    //
  }
}
